import {
  ComponentType,
  IComponentModel,
  IFrameComponentModel,
  IListComponentModel,
  IProductModel,
} from "@nf/common";
import { LANDING_PAGE_COMPONENT_TYPE } from "@nf/common/src/providers/DataProvider/RedBeeMedia/constants";

import { IFrame, ListComponentHorizontal } from "components";
import LandingPageHero from "components/LandingPage/LandingPageHero";
import LandingPageMovieSelection from "components/LandingPage/LandingPageMovieSelection";
import LandingPageChannels from "components/LandingPage/LandingPageChannels";
import LandingPageFAQ from "components/LandingPage/LandingPageFAQ";
import LandingPageJoinUs from "components/LandingPage/LandingPageJoinUs";

interface LandingPageSectionProps {
  component: IComponentModel;
  offers?: IProductModel[];
}

export const LandingPageSection = ({
  component,
  offers,
}: LandingPageSectionProps) => {
  switch (component.ComponentTypeCode) {
    case ComponentType.TextWidget:
      const textParsed = component.TextParsed;

      switch (textParsed?.type) {
        case LANDING_PAGE_COMPONENT_TYPE.HERO:
          return <LandingPageHero component={component} offers={offers} />;
        case LANDING_PAGE_COMPONENT_TYPE.MOVIE_SELECTION:
          return <LandingPageMovieSelection component={component} />;
        case LANDING_PAGE_COMPONENT_TYPE.CHANNELS:
          return <LandingPageChannels component={component} />;
        case LANDING_PAGE_COMPONENT_TYPE.FAQ:
          return <LandingPageFAQ component={component} />;
        case LANDING_PAGE_COMPONENT_TYPE.JOIN_US:
          return <LandingPageJoinUs component={component} offers={offers} />;
      }
    case ComponentType.List:
      return (
        <ListComponentHorizontal component={component as IListComponentModel} />
      );
    case ComponentType.Iframe:
      return <IFrame component={component as IFrameComponentModel} />;
    default:
      return null;
  }
};

export default LandingPageSection;
